<template>
  <div class="container">
    <h1>
      <button
        type="button"
        class="btn px-0 mx-0"
        title="Back"
        aria-label="Back"
        @click="(val) => $emit('advance', [1])"
        @keyup.enter="(val) => $emit('advance', [1])"
      >
        <Tcon icon="f-chevron-left" class="chevron-left" tabindex="0" />
      </button>
      Available Campaigns
    </h1>
    <div v-if="!this.loadingStore.isCampaignsAsyncing && currCampaigns.length === 0" class="error-msg">
      <p class="error-message">There are no active campaigns in this group</p>
    </div>
    <div class="card-group" v-else>
      <Card
        v-on="$listeners"
        v-for="campaign in currCampaigns"
        :key="campaign.campaign_id"
        :data="campaign"
        type="campaign"
        :id="campaign.campaign_id"
        :name="campaign.campaign_name"
        :start_date="campaign.start_date"
        :end_date="campaign.end_date"
        :step="step"
        @advance="handleNext"
      />
    </div>
  </div>
</template>

<script>
import Card from "./Card";
import axios from "axios";
import Tcon from "../iconography/Tcon";
import { LoadingStore } from "@/store/LoadingStore.js";

export default {
  name: "Campaigns",
  components: {
    Card,
    Tcon,
  },
  props: {
    step: Number,
    id: Number,
    campaignID: Number,
    campaigns: Array,
  },
  data() {
    return {
      loadingStore: LoadingStore(),
      currStep: this.step,
      currCampaigns: [],
      config: {
        headers: { "timezone-offset": new Date().getTimezoneOffset() / 60 },
      },
    };
  },
  created() {
    this.getStarted();
  },
  methods: {
    getStarted(){
      if (this.campaigns) {
      //Hide Campaigns without a valid cost center access and not admins or creator (like groups)
      this.currCampaigns = this.campaigns.filter((el) => {
        return (
          el.access.valid_cost_center ||
          el.access.member_type.includes("ADMIN") ||
          el.access.member_type.includes("CAMPAIGN_CREATOR") ||
          el.access.campaign_user_perms.length > 0
        );
      });
    } else if (!this.id && this.campaignID) {
      this.getAllCampaigns();
    } else {
      this.getCampaignsByGroup();
    }
    },
    getCampaignsByGroup() {
      this.loadingStore.isCampaignsAsyncing = true;
      this.loadingStore.type = "form";
      this.loadingStore.isLoading = true;
      axios
        .get(`admin/campaigns?groupID=${this.id}`, this.config)
        .then((response) => {
          if (response.data) {
            this.currCampaigns = response.data.filter(function(el) {
              //Hide inactive Campaigns without a valid cost center access and not admins or creator
              return (
                el.status === "Active" &&
                (el.access.valid_cost_center ||
                  el.access.member_type.includes("ADMIN") ||
                  el.access.member_type.includes("CAMPAIGN_CREATOR") ||
                  el.access.campaign_user_perms.length > 0)
              );
            });
          } else {
            this.currCampaigns = [];
          }
          this.$emit("load", this.currCampaigns);
        })
        .catch((error) => {
          console.error(error);
          // Auth and Cookie errors get caught by interceptor, other errors should route to error page
          setTimeout(() => {
            let errorMsg = error.response.data.UserMsgMap;
            this.$router.replace({ name: "error", params: { errorMsg } });
          }, 1000);
        })
        .finally(() => {
          this.loadingStore.isCampaignsAsyncing = false;
          this.loadingStore.isLoading = false;
          // regardless of where we started, use the 'form' loader from here on out
          this.loadingStore.type = "form";
        });
    },
    getAllCampaigns() {
      this.loadingStore.isCampaignsAsyncing = true;
      this.loadingStore.type = "form";
      this.loadingStore.isLoading = true;
      let _this = this;
      axios
        .get(`admin/campaigns`, this.config)
        .then((response) => {
          if (response.data) {
            const prevCampaign = response.data.filter(function(el) {
              return el.campaign_id === _this.campaignID;
            });
            const id = prevCampaign[0].group_id;
            this.$emit("update:id", id);
            this.currCampaigns = response.data.filter(function(el) {
              //Hide Campaigns without a valid cost center access and not admins or creator
              return (
                el.status === "Active" &&
                el.group_id === id &&
                (el.access.valid_cost_center ||
                  el.access.member_type.includes("ADMIN") ||
                  el.access.member_type.includes("CAMPAIGN_CREATOR") ||
                  el.access.campaign_user_perms.length > 0)
              );
            });
          } else {
            // just in case, this should only really call when we're coming back from form though
            this.currCampaigns = [];
          }
          this.$emit("load", this.currCampaigns);
          this.loadingStore.isLoading = true;
        })
        .catch((error) => {
          console.error(error);
          // Auth and Cookie errors get caught by interceptor, other errors should route to error page
          setTimeout(() => {
            let errorMsg = error.response.data.UserMsgMap;
            this.$router.replace({ name: "error", params: { errorMsg } });
          }, 1000);
        })
        .finally(() => {
          this.loadingStore.isCampaignsAsyncing = false;
          this.loadingStore.isLoading = false;
          // regardless of where we started, use the 'form' loader from here on out
          this.loadingStore.type = "form";
        });
    },
    handleNext(event) {
      this.$emit("advance", [event[0], event[1]]);
    },
  },
};
</script>

<style scoped>
.card-group {
  margin-right: -0.6rem;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: left;
}

.chevron-left {
  height: 2rem;
  width: 2rem;
}
.error-msg {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  margin: auto;
}

.error-message {
  align-self: center;
  margin-left: 5px;
  margin-bottom: 0;
}

h1 {
  margin-bottom: 1rem;
  font-size: 2rem;
  line-height: 2rem;
  vertical-align: midde;
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  overflow: scroll;
}
</style>
